export default __webpack_public_path__ + "static/media/b14.baa67971.jpg";